import React, { useEffect, useState } from 'react'
import { Upload, Button, message, Avatar as AntdAvatar } from 'antd'
import {
  CloseOutlined,  
  EditOutlined,
  UploadOutlined,
} from '@ant-design/icons'
import { GET_API_TOKEN, API_BASE_URL } from '../../constants/apiConstants'
import styled from 'styled-components'
import { RcFile } from 'antd/es/upload'
import { useDispatch, useSelector } from 'react-redux'
import {
  getImageUrl,
  selectImageUrl,
  selectProfilePictureImage,
  setImageFileNameToData,
} from '../../state/auth/authReducer'
import DummyAvatar from '../../assets/Avatar.png'
const baseUrl = API_BASE_URL

const UploadButton = styled(Button)`
  background-color: transparent;
  width: 300px;
  height: 300px;
  border-radius: 100%;
  gap: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 20px;
  color: white;
  font-size: large;
  font-weight: 600;
  background-color: rgba(0, 0, 0, 0.3);
  border-style: dashed;
  & span {
    margin-inline-start: 0px !important;
  }
`
const ImageContainer = styled.div`
  background-color: transparent;
  width: 300px;
  height: 300px;
  border-radius: 100%;
  gap: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid black;
  overflow: hidden;
`

const Image = styled.img`
  object-fit: contain;
  width: 100%;
  height: 100%;
`

const Avatar = styled(AntdAvatar)`
  object-fit: contain;
  width: 100%;
  height: 100%;
`

const ProfilePictureContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 20px;
  & .ant-upload-wrapper {
    display: flex;
    width: fit-content;
  }
`

export const ProfilePictureControl = styled.div`
  position: absolute;
  left: calc(50% + 300px / 2 + 5px);
  bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const IconButton = styled.button`
  background-color: transparent;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
`

const getBase64 = (img: RcFile, callback: (url: string) => void) => {
  const reader = new FileReader()
  reader.addEventListener('load', () => callback(reader.result as string))
  reader.readAsDataURL(img)
}

type ProfilePictureProps = {
  updateState: boolean
}

function ProfilePicture({ updateState }: ProfilePictureProps) {
  const [editState, setEditState] = useState<boolean>()
  const [loading, setLoading] = useState(false)
  const [imageUrl, setImageUrl] = useState<string>()
  const dispatch = useDispatch()
  const fileName = useSelector(selectProfilePictureImage)
  const profileImage = useSelector(selectImageUrl)
  useEffect(() => {
    dispatch(getImageUrl(fileName))
  }, [fileName])

  useEffect(() => {
    setImageUrl(profileImage)
  }, [profileImage])

  const uploadProps = {
    name: 'file',
    action: `${baseUrl}/api/rpmweb/file/profile`,
    headers: {
      authorization: `Bearer ${GET_API_TOKEN()}`,
    },
    showUploadList: false,
    onChange(info: any) {
      if (info.file.status === 'uploading') {
        setLoading(true)
      }

      if (info.file.status !== 'uploading') {
      }
      if (info.file.status === 'done') {
        getBase64(info.file.originFileObj as RcFile, (url) => {
          setLoading(false)
          setImageUrl(url)
          // setEditState(false)
        })
        let fileName = info.file.response.filename
        dispatch(setImageFileNameToData(fileName))
        message.success(`Image uploaded successfully`)
      } else if (info.file.status === 'error') {
        message.error(`Image upload failed.`)
      }
    },
  }
  useEffect(() => {
    setEditState(updateState)
  }, [updateState])
  return (
    <ProfilePictureContainer>
      {!editState ? (
        <ImageContainer>
          <Image src={imageUrl ?? DummyAvatar} alt='profilePic' />
        </ImageContainer>
      ) : (
        <Upload {...uploadProps}>
          <ImageContainer>
            {imageUrl ? (
              <Image src={imageUrl ?? DummyAvatar} alt='profilePic' />
            ) : (
              <Avatar />
            )}
          </ImageContainer>
          {editState && (
            <UploadButton>
              {' '}
              <UploadOutlined /> Upload File
            </UploadButton>
          )}
        </Upload>
      )}
      {updateState && (
        <ProfilePictureControl>
          <IconButton onClick={() => setEditState((prev) => !prev)}>
            {!editState ? <EditOutlined /> : <CloseOutlined />}
          </IconButton>
        </ProfilePictureControl>
      )}
    </ProfilePictureContainer>
  )
}

export default ProfilePicture
